<ul class="breadcrumbs">
    <li *ngFor="let item of breadcrumbs; let last = last" class="item">
        <a class="name" [routerLink]="item.url" [ngClass]="{'last-item': last}">{{item.name}} </a>
        <span *ngIf="!last" class="icon">
            <i class="material-icons">arrow_right</i>
        </span>
    </li>
</ul>
